<template>
	<div class="position-relative z-index-1045">
    <div class="row no-gutters justify-content-center">
      <div class="fixed-bottom d-table w-100 nav-bottom" style="top:40px">
        <div class="custom-container-fluid px-0">
        	<div class="row justify-content-center no-gutters">
            <div class="col-12 col-lg-9 position-relative">
              <div class="rounded-4 bg-white">
              	<div class="row no-gutters">
              		<div class="col-12 pop-up-currency-language position-relative h-96vh" style="overflow-y: scroll;height: 90vh;">
              			<img src="../../../../assets/img/icon/cancel.png"
                      class="d-inline-block p-2 rounded-3 bg-back mt-3 mx-4 cursor-pointer position-absolute"
                      width="33" 
                      style="z-index: 1038;right: 0"
                      @click="close()">
                      <div class="w-100 py-4 px-5">
                        <p class="mb-4 body-2-2 font-bold text-20 d-block">{{$t('hotel.choose-language')}}</p>
                        <div class="row slim-grid-row">
                          <div class="col-xl-4 col-lg-4 col-md-6 col-6 mb-3 rounded-6 cursor-pointer" @click="changeLanguage(list.iso_code)" :class="{'border-green cur-box-green':getCurrentLanguage() == list.iso_code,'cur-box':getCurrentLanguage() != list.iso_code}" v-for="list in language">
                            <div class="px-2 py-2 my-1">
                              <div class="d-inline-block">
                                <img :src="list.image_url" width="55" height="40" class="position-relative align-bottom rounded-3 object-fit border">
                              </div>
                              <div class="ml-2 d-inline-block position-relative" style="top: 1px">
                                <p 
                                  class="mb-0 body-2-2 text-14 font-semibold text-truncate" 
                                  :class="{'text-green':getCurrentLanguage() == list.iso_code}">
                                  {{list.name}}</p>
                                <p 
                                  class="mb-0 body-2 text-12 font-regular text-uppercase" 
                                  :class="{'text-green':getCurrentLanguage() == list.iso_code}">
                                  {{list.iso_code}}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="w-100 py-4 px-5">
                      	<p class="mb-4 body-2-2 font-bold text-20 d-block">{{$t('hotel.choose-currency')}}</p>
                      	<div class="row slim-grid-row">
                      		<div class="col-6 col-lg-3 mb-3 rounded-6"
                      		:class="{'cur-box': currency.code != getCurrency().code, 'border-green cur-box-green': currency.code == getCurrency().code,'cursor-pointer': !is_load, 'cursor-loading': is_load}"
                      		 v-for="currency in currencys"
                      		 @click="changeCurrency(currency)">
                      			<div class="p-2">
	                      			<p 
	                      				class="mb-0 body-2-2 text-14 font-semibold text-truncate" 
	                      				style="margin-bottom: -2px"
	                      				:class="{'text-green': currency.code == getCurrency().code}">{{currency.name}}</p>
	                      			<p 
	                      				class="mb-0 body-2 text-14 font-regular"
	                      				:class="{'text-green': currency.code == getCurrency().code}">
	                      				{{currency.code}} - {{currency.symbol_native}}
	                      			</p>
                      			</div>
                      		</div>
                      	</div>
                      </div>
              		</div>
              	</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
	import currency from "@/data/currency"
	import {mapGetters,mapMutations} from 'vuex'

	export default{
		data(){
			return{
				currencys: currency,
				is_load: false,
        language_selected: "",
        language: this.getMerchant().language
			}
		},
		methods:{
			...mapGetters(['getCurrency','getCurrentLanguage','getMerchant']),
			...mapMutations(['setCurrency','setBaseRate','setLanguageMutation']),
			close(){
				this.$emit('close',false)
			},
			changeCurrency(data){
				this.is_load = true
        this.$convertCurrency(data.code)
        .then(()=>{
          this.setCurrency(data)
          setTimeout(() => {
            this.close()
          },500)
        })
        .finally(()=>this.is_load)
			},
      changeLanguage(data){
        this.setLanguageMutation(data)
        window.location.reload();
      },
		}
	}
</script>
<style scoped>
	.cur-box:hover{
		background-color: #f2f2f2;
		transition: 0.3s;
	}
	.cur-box-green{
		background-color: #99FF001C;
	}
  @media screen and (max-width: 768px) {
    .pop-up-currency-language .px-5{
      padding-left: 28px!important;
      padding-right: 28px!important;
    }
    .h-96vh{
      height: 96vh!important;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/hotel/be/desktop/CurrencyAndLanguage.vue